import Vue from 'vue';
import InfiniteScroll from '../InfiniteScroll.vue';

const locale = window.LOCALE;
const baseUrl = locale ? `/${locale}/` : '/';
const isForSoldier = window.IS_FOR_SOLDIER;

var vm = new Vue({
	render(h) {
		return h(InfiniteScroll, {
			props: {
				apiUrl: `${baseUrl}defense/nextitem?publictionId=${window.PUBLICATION_ID}&isForSoldier=${isForSoldier}`
			},
			on: {
				loaded: el => {					
					SVGInjector(document.querySelectorAll('img.inject-me'));
					initSlickSlider($('.image-slider', el));
					viewportCheck($('.scroll-animate', el));	
					if (isForSoldier) {
						const formEl = $(el).find('.form-state-of-war');
						initFormStateOfWar(formEl);
					} else {
						initSubscribeValidation($('.form-subscribe', el));
					}

					if ($('.publication-with-author').length) {
						$('.publication-with-author').each(function() {
							var blockHeight = $(this).find('.author-column').height();
							$(this).css("min-height", blockHeight);
						});
					}
				}
			}
		});
	},
}).$mount('#publication_infinite_scroll');	